import React, { useEffect } from 'react';

import { Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import { threeSeconds } from 'components/common/timeUtils';
import { Translate } from 'react-localize-redux';
import { useHistory } from 'react-router-dom';

import { Typography } from '@fd/ui/atoms/Typography';
import LinkButton from '@fd/ui/Button/LinkButton';

import { ReactComponent as FlipdishLogo } from '../../assets/images/FlipdishLogo.svg';
import { accountRoutesConst } from '../../routes/account.routes';

const Page = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  gap: theme.spacing(2),
}));

const MainCard = styled(Card)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  width: '450px',
  maxWidth: '90vw',
  padding: '28px',
  borderRadius: '16px',
}));

const CardInner = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  paddingLeft: '0',
  paddingRight: '0',
}));

// Locally scale the SVG without affecting global asset usage
const LogoWrapper = styled('div')(() => ({
  width: '154px', // 110 * 1.4
  height: '50.4px', // 36 * 1.4
  lineHeight: 0,
}));

const ScaledLogo = styled(FlipdishLogo)(() => ({
  width: '110px',
  height: '36px',
  transform: 'scale(1.4)',
  transformOrigin: 'left top',
}));

const CardHeading = styled(Typography)(() => ({
  fontSize: '22px',
  fontWeight: '600',
}));

const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  marginTop: '20px',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

const ContinueButton = styled(LinkButton)(({ theme }) => ({
  textTransform: 'none',
  background: '#095FB0',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '600',
  padding: '10px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const LandingPage = () => {
  const history = useHistory();

  useEffect(() => {
    const id = setTimeout(() => {
      history.push(accountRoutesConst.Login);
    }, threeSeconds);
    return () => clearTimeout(id);
  }, [history]);

  const loginUrl = accountRoutesConst.Login;

  return (
    <Page>
      <MainCard>
        <CardInner>
          <LogoWrapper>
            <ScaledLogo />
          </LogoWrapper>
          <CardHeading variant="h4">
            <Translate id="Welcome" />
          </CardHeading>
          <Typography variant="body2" color="textSecondary">
            <Translate id="Easily_manage_your_restaurant_orders_marketing_rep" />
          </Typography>
          <ButtonContainer>
            <ContinueButton
              fdKey="Continue_with_secure_log_in"
              color="primary"
              to={loginUrl}
              type="button"
              variant="contained"
            >
              <Translate id="Continue_with_secure_log_in" />
            </ContinueButton>
          </ButtonContainer>
        </CardInner>
      </MainCard>
    </Page>
  );
};

export default LandingPage;
